export const isSameCalendarDay = (startDate: Date, endDate: Date) =>
  startDate.getFullYear() === endDate.getFullYear() &&
  startDate.getMonth() === endDate.getMonth() &&
  startDate.getDate() === endDate.getDate();

export const getSingleDayHourlyTickDates = (startDate: Date, endDate: Date) => {
  const tickValues: Date[] = [];
  const firstTickHour = startDate.getHours() + 1;
  const lastTickHour = endDate.getHours();

  for (let hour = firstTickHour; hour <= lastTickHour; hour++) {
    const tickDate = new Date(startDate);
    tickDate.setHours(hour, 0, 0, 0);
    tickValues.push(tickDate);
  }

  return tickValues;
};

export const formatMarketTime = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const displayHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;
  const ampm = hours >= 12 ? 'PM' : 'AM';

  if (minutes === 30) {
    return `${displayHours}:30 ${ampm}`;
  }

  return `${displayHours} ${ampm}`;
};

export const getMarketOpenAndCloseTickTimestamps = (
  domainMin: number,
  domainMax: number
) => {
  const tickValues: number[] = [];
  const startDate = new Date(domainMin);
  const endDate = new Date(domainMax);
  const current = new Date(startDate);
  current.setHours(0, 0, 0, 0);

  const endDay = new Date(endDate);
  endDay.setHours(23, 59, 59, 999);

  while (current <= endDay) {
    const open = new Date(current);
    open.setHours(9, 30, 0, 0);

    if (open.getTime() >= domainMin && open.getTime() <= domainMax) {
      tickValues.push(open.getTime());
    }

    const close = new Date(current);
    close.setHours(16, 0, 0, 0);

    if (close.getTime() >= domainMin && close.getTime() <= domainMax) {
      tickValues.push(close.getTime());
    }

    current.setDate(current.getDate() + 1);
  }

  return tickValues;
};
